import RecordPreview from "../components/generated-records/RecordPreview";

const RecordPreviewPage = () => {
  return (
    <>
      <RecordPreview />
    </>
  );
};

export default RecordPreviewPage;
